<template>
  <div class="container is-fluid has-text-centered">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <br />
    <div id="bafore_checksum" style="display: none">
      <div v-if="userData">
        <div id="url_expired">
          <h4>Welcome to Doodhvale, Please wait...</h4>
        </div>
        <div id="url_valid">
          <div>
            <div>
              <h4>Welcome {{ custName }}<br />({{ userDetails.mobile }})</h4>
            </div>
            <div>
              {{ custAddress }}
            </div>
            <div id="clear">
              <h4>No Dues</h4>
              <div class="pending_wallet">
                <i class="fa fa-rupee"></i><b>{{ apiDataObj.wallet_amount }}</b>
              </div>
            </div>
            <div id="pending">
              <h4>Pending Amount</h4>
              <div class="pending_wallet">
                <i class="fa fa-rupee"></i
                ><b>{{ apiDataObj.pending_amount }}</b>
              </div>
            </div>
            <div id="not_pending">
              <h4>Wallet Balance</h4>
              <div class="pending_wallet">
                <i class="fa fa-rupee"></i><b>{{ apiDataObj.wallet_amount }}</b>
              </div>
            </div>
            <div style="display: inline-block">
              <form>
                <div class="pending_wallet">
                  <h3>Enter Amount</h3>
                  <i class="fa fa-rupee"></i>
                  <!-- <input id="txn_amt" class="amount_text" name="TXN_AMOUNT" v-model="apiDataObj.default_amount" type="tel" oninput="this.value=this.value.replace(/[^0-9]/g,'');" placeholder="Amount" autofocus><br><br> -->
                  <input
                    ref="amountInput"
                    id="txn_amt"
                    class="amount_text"
                    name="TXN_AMOUNT"
                    v-model="rechargeAmount"
                    type="tel"
                    oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                    placeholder="0"
                    @focus="selectContent"
                  />
                </div>
                <br /><br />
                <b-notification
                  type="is-danger"
                  :closable="false"
                  :active.sync="isActive"
                >
                  {{ this.errors }}
                </b-notification>
                <div v-if="isQuickPaymentButtonDisplay === 1">
                  <input
                    class="quickPaymentButton"
                    v-model="btnOneValue"
                    type="button"
                    v-on:click="btnOneClick"
                  />
                  <input
                    style="margin-left: 10px"
                    class="quickPaymentButton"
                    v-model="btnTwoValue"
                    type="button"
                    v-on:click="btnTwoClick"
                  />
                  <input
                    style="margin-left: 10px"
                    class="quickPaymentButton"
                    v-model="btnThreeValue"
                    type="button"
                    v-on:click="btnThreeClick"
                  />
                </div>
                <div v-else>
                  <!-- <input class="quickPaymentButton" v-model="fiveDeliveryAmountLabel" type="button" v-on:click="fiveDeliveryBtnClick"> -->
                  <input
                    class="quickPaymentButton"
                    v-model="sevenDeliveryAmountLabel"
                    type="button"
                    v-on:click="sevenDeliveryBtnClick"
                  />
                  <input
                    style="margin-left: 10px"
                    class="quickPaymentButton"
                    v-model="fifteenDeliveryAmountLabel"
                    type="button"
                    v-on:click="fifteenDeliveryBtnClick"
                  />
                  <input
                    style="margin-left: 10px"
                    class="quickPaymentButton"
                    v-model="thirtyDeliveryAmountLabel"
                    type="button"
                    v-on:click="thirtyDeliveryBtnClick"
                  /><br />
                  <input
                    class="quickPaymentButton"
                    v-model="fourtyFiveDeliveryAmountLabel"
                    type="button"
                    v-on:click="fourtyFiveDeliveryBtnClick"
                  />
                  <input
                    style="margin-left: 10px"
                    class="quickPaymentButton"
                    v-model="sixtyDeliveryAmountLabel"
                    type="button"
                    v-on:click="sixtyDeliveryBtnClick"
                  />
                  <!-- <input style="margin-left: 10px;" class="quickPaymentButton" v-model="ninetyDeliveryAmountLabel" type="button" v-on:click="ninetyDeliveryBtnClick"> -->
                </div>
                <!-- priya (coupon) -->
                <div class="wallet_coupon_block">
                  <!--div class="wallet_coupon_heading">Apply Coupon</div-->
                  <div class="wallet_coupon_rl">
                    <div>
                      <div class="apply_block">
                        <img src="../../../../static/img/ic_sale.png" />
                        <div>
                          <p
                            class="wallet_coupon_et"
                            :style="{ color: isGreen ? '#3CB6C3' : '#000000' }"
                          >
                            {{ walletCouponMsg }}
                          </p>
                          <p
                            class="wallet_coupon_msg"
                            :style="{ color: isGreen ? '#0E8642' : '#ff4c4c' }"
                          >
                            {{ couponMsg }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="coupon_img" v-on:click="applyCouponClick">
                      <div v-if="applyCouponImg == 1">
                        <img
                          src="../../../../static/img/ic_right_arrow_icon.png"
                        />
                      </div>
                      <div v-else>
                        <img src="../../../../static/img/cross_icon.png" />
                      </div>
                    </div>
                  </div>
                </div>
                <!--div class="paymentType" style="text-align: left;">
                  <h4 style="font-weight:bold;letter-spacing: 0;margin: 20px 0px;">Debit From</h4>
                  <p v-if="apiDataObj.cc !== '0'">
                  <input  type="radio" id="cc" value="cc" v-model="payment_type" name="walletType">
                  <label  for="cc">Credit, Debit Card / Net Banking </label><img  src="../../../../static/img/creditcard.png"/></p>
                  <p v-if="apiDataObj.upi !== '0'">
                  <input  type="radio" id="upi" value="upi" v-model="payment_type" name="walletType">
                  <label  for="upi">UPI </label><img  src="../../../../static/img/upi.png" /></p>
                  <p v-if="apiDataObj.paytm !== '0'">
                  <input  type="radio" id="paytm" value="paytm" v-model="payment_type" name="walletType">
                  <label for="paytm">Paytm Wallet </label><img  src="../../../../static/img/paytm.png" /></p>
                  <p v-if="apiDataObj.mobikwik !== '0'">
                  <input  type="radio" id="mobikwik" value="mobikwik" v-model="payment_type" name="walletType">
                  <label  for="mobikwik">Mobikwik Wallet </label><img  src="../../../../static/img/mobikwik.png" /></p>
                  <p v-if="apiDataObj.ola !== '0'">
                  <input  type="radio" id="ola" value="ola" v-model="payment_type" name="walletType">
                  <label  for="ola">OLA Money Wallet </label><img  src="../../../../static/img/olamoney.png"/></p>
                  <p v-if="apiDataObj.jio !== '0'">
                  <input  type="radio" id="jio" value="jio" v-model="payment_type" name="walletType">
                  <label for="jio">JIO Money Wallet</label><img src="../../../../static/img/jiomoney.png" /> </p>
                  <p v-if="apiDataObj.freecharge !== '0'">  
                  <input  type="radio" id="freecharge" value="freecharge" v-model="payment_type" name="walletType">
                  <label for="freecharge">FreeCharge Wallet</label>
                  <img  src="../../../../static/img/freecharge.png" />
                </p>
                </div--><br />
                <input
                  class="button3"
                  value="Payment Now"
                  type="button"
                  v-on:click="
                    isCouponApplied
                      ? checkCorrectCouponApplied()
                      : generateChecksum()
                  "
                />
                <!-- priya -->
                <div class="checkAmtBox" v-if="showCouponAlertBox">
                  <div class="alert-box">
                    <h4 style="font-weight: bold">{{ alertHeading }}</h4>
                    <p>{{ alertMessage }}</p>
                    <div class="alert-btn">
                      <button v-on:click="handleRetry($event)">Retry</button>
                      <button v-on:click="handleIgnoreCoupon($event)">
                        Ignore Coupon
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- priya (showAnimation) -->
          <div class="dialogBox" v-if="showDialog">
            <CouponAnimation />
          </div>
        </div>
        <div v-if="showToast" class="toast">
          {{ toastMessage }}
        </div>
      </div>
    </div>
    <div v-if="after_checksum">
      <div>
        <br />
        Dear {{ userDetails.first_name }}
        <br />
        Please press button to continue
        <br /><br />
        Amount<i class="fa fa-rupee"></i><b>{{ genChecksum.TXN_AMOUNT }}</b
        ><br /><br />
        <div>
          <form
            method="post"
            action="https://securegw.paytm.in/theia/processTransaction"
          >
            <!--  <form method="post" action="https://pguat.paytm.com/oltp-web/processTransaction"> --><!-- staging -->
            <input type="hidden" name="MID" v-model="genChecksum.MID" />
            <input
              type="hidden"
              name="ORDER_ID"
              v-model="genChecksum.ORDER_ID"
            />
            <input type="hidden" name="CUST_ID" v-model="genChecksum.CUST_ID" />
            <input
              type="hidden"
              name="INDUSTRY_TYPE_ID"
              v-model="genChecksum.INDUSTRY_TYPE_ID"
            />
            <input
              type="hidden"
              name="CHANNEL_ID"
              v-model="genChecksum.CHANNEL_ID"
            />
            <input type="hidden" name="WEBSITE" v-model="genChecksum.WEBSITE" />
            <input
              type="hidden"
              name="CALLBACK_URL"
              v-model="genChecksum.CALLBACK_URL"
            />
            <input
              type="hidden"
              name="CHECKSUMHASH"
              v-model="genChecksum.checksum"
            />
            <input
              type="hidden"
              name="TXN_AMOUNT"
              v-model="genChecksum.TXN_AMOUNT"
            />
            <input
              type="hidden"
              name="MERC_UNQ_REF"
              v-model="genChecksum.MERC_UNQ_REF"
            />
            <!-- priya -->
            <input type="hidden" name="promo_code_id" v-model="promoCodeId" />
            <input type="hidden" name="promo_code_str" v-model="promoCodeStr" />
            <input type="hidden" name="cashback_amount" v-model="cashback" />
            <input
              id="pay"
              class="button5"
              value="Continue"
              type="submit"
              v-on:click="isLoading = true"
            />
          </form>
        </div>
      </div>
    </div>
    <div v-if="app_payment_gate" style="display: none !important">
      <div>
        <br />
        Dear {{ userDetails.first_name }}
        <br />
        Please press button to continue
        <br />
        <br />
        Amount<i class="fa fa-rupee"></i
        ><b>{{ appPaymentGateway.TXN_AMOUNT }}</b
        ><br /><br />
        <div>
          <!-- <form method="post" v-on:{{appPaymentGateway.actionUrl}}> -->
          <!-- <form method="post" action="http://localhost:8888/doodhvale-admin/doodhvale/api/modules/v3/controllers/ccavRequestHandler.php"> -->
          <form
            method="post"
            name="hdfcform"
            id="hdfcform"
            :action="appPaymentGateway.actionUrl"
          >
            <!-- <form method="post" action="https://pguat.paytm.com/oltp-web/processTransaction"> --><!-- staging -->
            <input type="hidden" name="tid" v-model="appPaymentGateway.TID" />
            <!-- for test key-->
            <!--  <input type="hidden" name="merchant_id" value="208602"/> -->
            <!-- for prod key-->
            <input type="hidden" name="merchant_id" value="242357" />
            <input
              type="hidden"
              name="order_id"
              v-model="appPaymentGateway.ORDER_ID"
            />
            <input
              type="hidden"
              name="amount"
              v-model="appPaymentGateway.TXN_AMOUNT"
            />
            <input type="hidden" name="currency" value="INR" />
            <input
              type="hidden"
              name="redirect_url"
              v-model="appPaymentGateway.responseUrl"
            />
            <input
              type="hidden"
              name="cancel_url"
              v-model="appPaymentGateway.responseUrl"
            />
            <input type="hidden" name="language" value="EN" />
            <input
              type="hidden"
              name="delivery_name"
              v-model="userDetails.fullName"
            />
            <input
              type="hidden"
              name="delivery_address"
              v-model="userDetails.address"
            />
            <input
              type="hidden"
              name="delivery_city"
              v-model="userDetails.city"
            />
            <input
              type="hidden"
              name="delivery_state"
              v-model="userDetails.state"
            />
            <input
              type="hidden"
              name="delivery_zip"
              v-model="userDetails.pincode"
            />
            <input type="hidden" name="delivery_country" value="India" />
            <input
              type="hidden"
              name="delivery_tel"
              v-model="userDetails.mobile"
            />
            <input
              type="hidden"
              name="merchant_param1"
              v-model="apiDataObj.userId"
            />
            <input
              type="hidden"
              name="merchant_param2"
              v-model="appPaymentGateway.CALLBACK_URL"
            />
            <input
              type="hidden"
              name="merchant_param3"
              v-model="appPaymentGateway.APP_PAYMENT_GATEWAY"
            />
            <input
              type="hidden"
              name="merchant_param4"
              v-model="appPaymentGateway.apiUrl"
            />
            <input
              type="hidden"
              name="merchant_param4"
              v-model="appPaymentGateway.apiUrl"
            />
            <!-- priya -->
            <input type="hidden" name="promo_code_id" v-model="promoCodeId" />
            <input type="hidden" name="promo_code_str" v-model="promoCodeStr" />
            <input type="hidden" name="cashback_amount" v-model="cashback" />
            <input
              id="pay"
              class="button5"
              value="Continue"
              type="submit"
              v-on:click="isLoading = true"
            />
          </form>
        </div>
      </div>
    </div>
    <div v-if="payu_payment_gate" style="display: none !important">
      <div>
        <div>
          <form
            method="post"
            :action="appPaymentGateway.actionUrl"
            name="payuform"
            id="payuform"
          >
            <input type="hidden" name="hash" v-model="appPaymentGateway.HASH" />
            <input
              type="hidden"
              name="txnid"
              v-model="appPaymentGateway.ORDER_ID"
            />
            <input
              type="hidden"
              name="amount"
              v-model="appPaymentGateway.TXN_AMOUNT"
            />
            <input type="hidden" name="currency" value="INR" />
            <input
              type="hidden"
              name="surl"
              v-model="appPaymentGateway.responseUrl"
            />
            <input
              type="hidden"
              name="furl"
              v-model="appPaymentGateway.responseUrl"
            />
            <input type="hidden" name="language" value="EN" />
            <input
              type="hidden"
              name="firstname"
              v-model="userDetails.first_name"
            />
            <input
              type="hidden"
              name="address1"
              v-model="userDetails.address"
            />
            <input type="hidden" name="city" v-model="userDetails.city" />
            <input type="hidden" name="state" v-model="userDetails.state" />
            <input type="hidden" name="Zipcode" v-model="userDetails.pincode" />
            <input type="hidden" name="country" value="India" />
            <input type="hidden" name="phone" v-model="userDetails.mobile" />
            <input
              type="hidden"
              name="merchant_param1"
              v-model="apiDataObj.userId"
            />
            <input
              type="hidden"
              name="merchant_param2"
              v-model="appPaymentGateway.CALLBACK_URL"
            />
            <input
              type="hidden"
              name="merchant_param3"
              v-model="appPaymentGateway.APP_PAYMENT_GATEWAY"
            />
            <input
              type="hidden"
              name="merchant_param4"
              v-model="appPaymentGateway.apiUrl"
            />
            <input type="hidden" name="promo_code_id" v-model="promoCodeId" />
            <input type="hidden" name="promo_code_str" v-model="promoCodeStr" />
            <input type="hidden" name="cashback_amount" v-model="cashback" />
            <input
              id="pay"
              class="button5"
              value="Continue"
              type="submit"
              v-on:click="isLoading = true"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import ChartCard from "src/components/UIComponents/Cards/ChartCard.vue";
import StatsCard from "src/components/UIComponents/Cards/StatsCard.vue";
import Card from "src/components/UIComponents/Cards/Card.vue";
import LTable from "src/components/UIComponents/Table.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
import axios from "axios";
import CouponAnimation from "../Layout/CouponAnimation.vue";

// import VueAxios from 'vue-axios'
export default {
  components: {
    Checkbox,
    Card,
    LTable,
    ChartCard,
    StatsCard,
    CouponAnimation,
  },
  data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      genChecksum: [],
      appPaymentGateway: [],
      after_checksum: false,
      userData: true,
      app_payment_gate: false,
      payu_payment_gate: false,
      payment_type: "cc",
      errors: "",
      isActive: false,
      isLoading: true,
      isLoaded: false,
      isFullPage: true,
      btnOneValue: 500,
      btnTwoValue: 1000,
      btnThreeValue: 1500,
      isQuickPaymentButtonDisplay: 1,
      fiveDeliveryAmount: 100,
      sevenDeliveryAmount: 200,
      fifteenDeliveryAmount: 400,
      thirtyDeliveryAmount: 800,
      fourtyFiveDeliveryAmount: 1200,
      sixtyDeliveryAmount: 1600,
      ninetyDeliveryAmount: 2400,
      custName: "",
      custAddress: "",
      fiveDeliveryAmountLabel: "5 Deliveries",
      sevenDeliveryAmountLabel: "7 Deliveries",
      fifteenDeliveryAmountLabel: "15 Deliveries",
      thirtyDeliveryAmountLabel: "30 Deliveries",
      fourtyFiveDeliveryAmountLabel: "45 Deliveries",
      sixtyDeliveryAmountLabel: "60 Deliveries",
      ninetyDeliveryAmountLabel: "90 Deliveries",
      // priya
      isCouponApplied: false,
      applyCouponImg: 1,
      couponCode: "",
      verifyWalletResponse: {},
      couponMsg: "",
      isGreen: 1,
      walletCouponMsg: "Avail Offers / Coupons",
      rechargeAmount: 0,
      showDialog: false,
      showCouponAlertBox: false,
      alertHeading: "",
      alertMessage: "",
      showToast: false,
      toastMessage: "",
      promoCodeId: "0",
      promoCodeStr: "",
      cashback: "0",
    };
  },
  created() {
    if (sessionStorage.getItem("paymentFlow") === "editSubscription") {
      sessionStorage.removeItem("paymentFlow");
      this.$router.push("/a/editSubscription");
    } else {
      this.fetchData();
    }
  },
  // priya
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (sessionStorage.getItem("couponClicked") == 1) {
        vm.checkCouponApplied(from.params);
        sessionStorage.removeItem("couponClicked");
        setTimeout(() => {
          vm.$nextTick(() => {
            vm.scrollToBottom();
          });
        }, 13000);
      } else {
        vm.rechargeAmount = sessionStorage.getItem("rechargeAmount")
          ? sessionStorage.getItem("rechargeAmount")
          : 0;
        // console.log("coupon not applied")
      }
    });
  },
  methods: {
    fetchData() {
      const params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split("p?");
      params.append("url_str", splitUrl[1]);
      sessionStorage.setItem("paymentUrl", splitUrl[1]);
      axios({
        url: process.env.BASE_API + "/accounts/fetch-url-interface-data",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          this.urlInterface = {};
          if (
            response.data.status === "000001" ||
            response.data.status === "000002" ||
            response.data.status === "000003"
          ) {
            this.urlInterface.error_msg = response.data.msg;
            if (document.getElementById("url_valid") !== null) {
              document.getElementById("url_valid").style.display = "none";
            }
          } else {
            if (document.getElementById("url_expired") !== null) {
              document.getElementById("url_expired").style.display = "none";
            }
            this.urlInterface.action_name = response.data.action_name;
            this.urlInterface.url_interface_id = response.data.url_interface_id;
            this.urlInterface.vue_url = fullUrl;
            this.urlInterface.callback_url =
              process.env.PAGE_URL + "/controllers/pgResponse.php";
            this.invokeUrlAction();
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            this.list = response.data.user_record;
            alert(this.list);
          }
          setTimeout(() => {
            if (document.getElementById("bafore_checksum") !== null) {
              document.getElementById("bafore_checksum").style.display =
                "block";
            }
            this.isLoading = false;
          }, 10000);
        })
        .catch((e) => {
          if (document.getElementById("bafore_checksum") !== null) {
            document.getElementById("bafore_checksum").style.display = "block";
          }
          this.isLoading = false;
          alert("not ok");
        });
    },

    invokeUrlAction() {
      const params = new URLSearchParams();
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      axios({
        url: process.env.BASE_API + "/accounts/invoke-url-action",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (
            response.data.action_response.user_id === null ||
            response.data.action_response.user_id === 0 ||
            response.data.action_response.user_id === "0" ||
            response.data.action_response.user_id === "undefined"
          ) {
            window.location.reload();
          }
          this.apiDataObj = {};
          switch (this.urlInterface.action_name) {
            case "cow_milk_bill":
              // for cow milk billing
              break;
            case "pending_bill_payment":
              // console.log(response)
              this.apiDataObj.userId = response.data.action_response.user_id;
              this.apiDataObj.payment_gateway =
                response.data.action_response.app_payment_gateway_v2;
              this.apiDataObj.app_payment_gateway =
                response.data.action_response.app_payment_gateway_v2;
              // ///////// start for payment option //////
              this.apiDataObj.cc = response.data.action_response.app_payment_cc;
              this.apiDataObj.upi =
                response.data.action_response.app_payment_upi;
              this.apiDataObj.paytm =
                response.data.action_response.app_payment_wallet_paytm;
              this.apiDataObj.mobikwik =
                response.data.action_response.app_payment_wallet_mobikwik;
              this.apiDataObj.ola =
                response.data.action_response.app_payment_wallet_olamoney;
              this.apiDataObj.jio =
                response.data.action_response.app_payment_wallet_jiomoney;
              this.apiDataObj.freecharge =
                response.data.action_response.app_payment_wallet_freecharge;
              // ///////// end for payment option //////
              this.apiDataObj.pending_amount = Math.ceil(
                response.data.action_response.pending_amount
              );
              // console.log(response.data.action_response.is_quick_payment_button_display)
              this.isQuickPaymentButtonDisplay =
                response.data.action_response.is_quick_payment_button_display;
              if (this.isQuickPaymentButtonDisplay === 0) {
                this.fiveDeliveryAmount =
                  response.data.action_response.five_deliveries_amount;
                this.sevenDeliveryAmount =
                  response.data.action_response.seven_deliveries_amount;
                this.fifteenDeliveryAmount =
                  response.data.action_response.fifteen_deliveries_amount;
                this.thirtyDeliveryAmount =
                  response.data.action_response.thirty_deliveries_amount;
                this.fourtyFiveDeliveryAmount =
                  response.data.action_response.fourty_five_deliveries_amount;
                this.sixtyDeliveryAmount =
                  response.data.action_response.sixty_deliveries_amount;
                this.ninetyDeliveryAmount =
                  response.data.action_response.ninety_deliveries_amount;
              }
              // this.apiDataObj.pending_amount = -5
              this.apiDataObj.wallet_amount = 0;
              if (this.apiDataObj.pending_amount > 0) {
                if (document.getElementById("not_pending") !== null) {
                  document.getElementById("not_pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
              } else {
                if (document.getElementById("pending") !== null) {
                  document.getElementById("pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
                this.apiDataObj.wallet_amount = Math.abs(
                  this.apiDataObj.pending_amount
                );
                this.apiDataObj.pending_amount = 0;
              }
              this.apiDataObj.default_amount = this.apiDataObj.pending_amount;
              // ch
              // this.rechargeAmount = this.apiDataObj.pending_amount
              this.pendingBillPayment();
              break;
            case "order_flow_payment":
              // console.log(response)
              this.apiDataObj.userId = response.data.action_response.user_id;
              this.apiDataObj.payment_gateway =
                response.data.action_response.app_payment_gateway_v2;
              this.apiDataObj.app_payment_gateway =
                response.data.action_response.app_payment_gateway_v2;
              // ///////// start for payment option //////

              this.apiDataObj.cc = response.data.action_response.app_payment_cc;
              this.apiDataObj.upi =
                response.data.action_response.app_payment_upi;
              this.apiDataObj.paytm =
                response.data.action_response.app_payment_wallet_paytm;
              this.apiDataObj.mobikwik =
                response.data.action_response.app_payment_wallet_mobikwik;
              this.apiDataObj.ola =
                response.data.action_response.app_payment_wallet_olamoney;
              this.apiDataObj.jio =
                response.data.action_response.app_payment_wallet_jiomoney;
              this.apiDataObj.freecharge =
                response.data.action_response.app_payment_wallet_freecharge;

              // ///////// end for payment option //////
              this.apiDataObj.pending_amount = Math.ceil(
                response.data.action_response.pending_amount
              );
              this.apiDataObj.default_amount = Math.ceil(
                response.data.action_response.default_amount
              );
              // ch
              // this.rechargeAmount = Math.ceil(response.data.action_response.default_amount)
              // this.apiDataObj.pending_amount = -5
              this.apiDataObj.wallet_amount = 0;
              if (this.apiDataObj.pending_amount > 0) {
                if (document.getElementById("not_pending") !== null) {
                  document.getElementById("not_pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
              } else {
                if (document.getElementById("pending") !== null) {
                  document.getElementById("pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
                this.apiDataObj.wallet_amount = Math.abs(
                  this.apiDataObj.pending_amount
                );
                this.apiDataObj.pending_amount = 0;
              }
              this.pendingBillPayment();
              break;
            default:
              break;
          }
          // if (this.apiDataObj.default_amount > 0) {
          //   this.btnOneValue = ((parseInt(this.apiDataObj.default_amount / 500)) + 1) * 500
          if (this.rechargeAmount > 0) {
            this.btnOneValue = (parseInt(this.rechargeAmount / 500) + 1) * 500;
            this.btnTwoValue = this.btnOneValue + 500;
            this.btnThreeValue = this.btnOneValue + 1000;
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            this.list = response.data.user_record;
            alert(this.list);
          }
        })
        .catch((e) => {
          alert("not ok");
        });
    },

    btnOneClick() {
      document.getElementById("txn_amt").value = this.btnOneValue;
      // this.apiDataObj.default_amount = this.btnOneValue
      this.rechargeAmount = this.btnOneValue;
    },

    btnTwoClick() {
      document.getElementById("txn_amt").value = this.btnTwoValue;
      // this.apiDataObj.default_amount = this.btnTwoValue
      this.rechargeAmount = this.btnTwoValue;
    },

    btnThreeClick() {
      document.getElementById("txn_amt").value = this.btnThreeValue;
      // this.apiDataObj.default_amount = this.btnThreeValue
      this.rechargeAmount = this.btnThreeValue;
    },

    fiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fiveDeliveryAmount;
    },

    sevenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sevenDeliveryAmount;
    },

    fifteenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fifteenDeliveryAmount;
    },

    thirtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.thirtyDeliveryAmount;
    },

    fourtyFiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fourtyFiveDeliveryAmount;
    },

    sixtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sixtyDeliveryAmount;
    },

    ninetyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.ninetyDeliveryAmount;
    },

    pendingBillPayment() {
      const params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      axios({
        url: process.env.BASE_API + "/users/user-info",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (document.getElementById("txn_amt") !== null) {
            document.getElementById("txn_amt").focus();
          }
          this.userDetails = {};
          this.userDetails.userId = userId;
          this.userDetails.first_name =
            response.data.user_record.user_details.first_name;
          this.userDetails.mobile = response.data.user_record.user.username;
          this.userDetails.address =
            response.data.user_record.address.address1 +
            " " +
            response.data.user_record.address.address2 +
            " " +
            response.data.user_record.address.city;
          this.userDetails.pincode = response.data.user_record.address.pincode;
          this.userDetails.city = response.data.user_record.address.city;
          this.userDetails.state = response.data.user_record.address.state;
          this.userDetails.fullName =
            response.data.user_record.user_details.first_name +
            " " +
            response.data.user_record.user_details.last_name;
          this.custName = this.userDetails.fullName;
          this.custAddress = this.userDetails.address;
          this.userDetails.fullName = this.userDetails.fullName.replace(
            /[^a-zA-Z0-9 ]/g,
            ""
          );
          this.userDetails.address = this.userDetails.address.replace(
            /[^a-zA-Z0-9 ]/g,
            ""
          );
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            this.list = response.data.user_record;
            alert(this.list);
          }
        })
        .catch((e) => {
          alert("not ok");
        });
    },
    onAmmountChange() {
      this.errors = "";
      this.isActive = false;
      document.getElementById("txn_amt").value = Number(
        document.getElementById("txn_amt").value
      );
    },
    generateChecksum() {
      if (sessionStorage.getItem("paymentFlow") !== null) {
        sessionStorage.setItem("paymentFlow", "editSubscription");
      }
      /* var paymentType = '2'
          switch (this.payment_type) {
            case 'cc':
              paymentType = this.apiDataObj.cc
              break
            case 'upi':
              paymentType = this.apiDataObj.upi
              break
            case 'paytm':
              paymentType = this.apiDataObj.paytm
              break
            case 'mobikwik':
              paymentType = this.apiDataObj.mobikwik
              break
            case 'ola':
              paymentType = this.apiDataObj.ola
              break
            case 'jio':
              paymentType = this.apiDataObj.jio
              break
            case 'freecharge':
              paymentType = this.apiDataObj.freecharge
              break
            default:
          }
          this.apiDataObj.app_payment_gateway = paymentType
          if (paymentType === '1') {
            this.paytm()
          } else {
            if (this.apiDataObj.app_payment_gateway === '1') {
              this.paytm()
            } else {
              this.hdfc()
            }
          } */
      if (this.apiDataObj.app_payment_gateway == "payu") {
        this.payumoney();
      } else {
        this.hdfc();
      }
    },
    paytm() {
      var orderId = "";
      const params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      params.append("gateway_name", "paytm");
      axios({
        url: process.env.BASE_API + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
            orderId = response.data.unique_order_id;
            const params = new URLSearchParams();
            // var userId = this.apiDataObj.userId
            var txnAmount = document.getElementById("txn_amt").value;
            if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
              document.getElementById("txn_amt").focus();
              this.errors = "Oops! Invalid Amount.";
              this.isActive = true;
              setTimeout(() => {
                this.errors = "";
                this.isActive = false;
              }, 10000);
            } else {
              this.isLoading = false;
              // var orderId = 'DVWP' + Math.floor(Math.random() * 10000000)
              params.append("CUST_ID", userId);
              params.append("ORDER_ID", orderId);
              params.append("CHANNEL_ID", "WEB");
              params.append("WEBSITE", "SanjeeWEB");
              // params.append('WEBSITE', 'APP_STAGING')// staging
              params.append("TXN_AMOUNT", txnAmount);
              params.append(
                "MERC_UNQ_REF",
                userId +
                  "br" +
                  this.urlInterface.vue_url +
                  "br" +
                  process.env.BASE_API +
                  "/accounts/verify-transaction"
              );
              params.append("CALLBACK_URL", this.urlInterface.callback_url);
              // priya
              params.append("promo_code_id", this.promoCodeId);
              params.append("promo_code_str", this.promoCodeStr);
              params.append("cashback_amount", this.cashback);
              axios({
                url: process.env.BASE_API + "/accounts/generate-checksum",
                method: "post",
                data: params,
                withCredentials: false,
                headers: {},
              })
                .then((response) => {
                  this.genChecksum = {};
                  this.genChecksum.MID = response.data.post_value.MID;
                  this.genChecksum.ORDER_ID = response.data.post_value.ORDER_ID;
                  this.genChecksum.CUST_ID = response.data.post_value.CUST_ID;
                  this.genChecksum.INDUSTRY_TYPE_ID =
                    response.data.post_value.INDUSTRY_TYPE_ID;
                  this.genChecksum.CHANNEL_ID =
                    response.data.post_value.CHANNEL_ID;
                  this.genChecksum.WEBSITE = response.data.post_value.WEBSITE;
                  this.genChecksum.TXN_AMOUNT =
                    response.data.post_value.TXN_AMOUNT;
                  this.genChecksum.CALLBACK_URL =
                    response.data.post_value.CALLBACK_URL;
                  this.genChecksum.MERC_UNQ_REF =
                    response.data.post_value.MERC_UNQ_REF;
                  this.genChecksum.checksum = response.data.checkSum;
                  this.after_checksum = true;
                  this.userData = false;
                  this.app_payment_gate = false;
                  this.payu_payment_gate = false;
                  // console.log(response)
                  if (response.data.status.trim().toUpperCase() === "SUCCESS") {
                    this.list = response.data.user_record;
                    alert(this.list);
                  }
                })
                .catch((e) => {
                  alert("not ok");
                });
            }
          }
        })
        .catch((e) => {
          this.errors = "Server error, Try again!";
          this.isActive = true;
        });
    },
    hdfc() {
      var orderId = "";
      var userId = this.apiDataObj.userId;
      const params = new URLSearchParams();
      params.append("user_id", userId);
      params.append("gateway_name", "hdfc");
      axios({
        url: process.env.BASE_API + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
            orderId = response.data.unique_order_id;
            // var userId = this.apiDataObj.userId
            var txnAmount = Number(document.getElementById("txn_amt").value);
            if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
              document.getElementById("txn_amt").focus();
              this.errors = "Oops! Invalid Amount.";
              this.isActive = true;
            } else {
              this.after_checksum = false;
              this.userData = false;
              this.app_payment_gate = true;
              this.payu_payment_gate = false;
              this.appPaymentGateway = {};
              this.appPaymentGateway.TXN_AMOUNT = txnAmount;
              this.appPaymentGateway.ORDER_ID = orderId; // 'DVWH' + Math.floor(Math.random() * 10000000)
              this.appPaymentGateway.TID = new Date().getTime();
              this.appPaymentGateway.CALLBACK_URL = this.urlInterface.vue_url;
              this.appPaymentGateway.APP_PAYMENT_GATEWAY =
                this.apiDataObj.app_payment_gateway;
              this.appPaymentGateway.actionUrl =
                process.env.PAGE_URL + "/controllers/ccavRequestHandler.php";
              this.appPaymentGateway.responseUrl =
                process.env.PAGE_URL + "/controllers/ccavResponseHandler.php";
              this.appPaymentGateway.apiUrl =
                process.env.BASE_API + "/accounts/payment-gateway-transaction";
              setTimeout(function () {
                document.getElementById("hdfcform").submit();
              }, 300);
            }
          }
        })
        .catch((e) => {
          this.errors = "Server error, Try again!";
          this.isActive = true;
        });
      this.isLoading = false;
    },
    payumoney() {
      var orderId = "";
      const params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      params.append("gateway_name", "payu");
      axios({
        url: process.env.BASE_API + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
            orderId = response.data.unique_order_id;
            this.appPaymentGateway = {};
            this.appPaymentGateway.user_id = userId;
            const params = new URLSearchParams();
            var txnAmount = document.getElementById("txn_amt").value;
            if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
              document.getElementById("txn_amt").focus();
              this.errors = "Oops! Invalid Amount.";
              this.isActive = true;
            } else {
              this.appPaymentGateway.TXN_AMOUNT = txnAmount;
              this.isLoading = false;
              params.append("merchant_param1", userId);
              params.append("order_id", orderId);
              var firstname = this.userDetails.first_name;
              params.append("amount", txnAmount);
              params.append("delivery_name", firstname);
              params.append("merchant_param2", this.urlInterface.vue_url);
              params.append(
                "merchant_param4",
                process.env.BASE_API + "/accounts/payment-gateway-transaction"
              );
              params.append("CALLBACK_URL", this.urlInterface.vue_url);
              params.append("promo_code_id", this.promoCodeId);
              params.append("promo_code_str", this.promoCodeStr);
              params.append("cashback_amount", this.cashback);
              axios({
                url:
                  process.env.BASE_API + "/payumoneypayments/payment-initiate",
                method: "post",
                data: params,
                withCredentials: false,
                headers: {},
              })
                .then((response) => {
                  this.after_checksum = false;
                  this.userData = false;
                  this.app_payment_gate = false;
                  this.payu_payment_gate = true;
                  // this.appPaymentGateway = {};
                  this.appPaymentGateway.HASH = response.data.hash;
                  this.appPaymentGateway.ORDER_ID = response.data.order_id;
                  this.appPaymentGateway.CALLBACK_URL =
                    this.urlInterface.vue_url;
                  this.appPaymentGateway.APP_PAYMENT_GATEWAY =
                    this.apiDataObj.app_payment_gateway_v2;
                  this.appPaymentGateway.actionUrl =
                    process.env.PAGE_URL +
                    "/controllers/payuRequestHandler.php";
                  this.appPaymentGateway.responseUrl =
                    process.env.PAGE_URL +
                    "/controllers/payuResponseHandler.php";
                  setTimeout(function () {
                    document.getElementById("payuform").submit();
                  }, 300);
                })
                .catch((e) => {
                  alert("not ok");
                });
            }
          }
        })
        .catch((e) => {
          this.errors = "Server error, Try again!";
          this.isActive = true;
        });
    },
    isNumber: function (evt) {
      if (!evt) {
        evt = window.event;
      }
      // evt = (evt) ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // priya
    scrollToBottom() {
      this.$nextTick(() => {
        let currentScroll = 0;
        let totalHeight =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight;
        let interval = setInterval(() => {
          if (currentScroll >= totalHeight) {
            clearInterval(interval);
          } else {
            currentScroll += 12;
            window.scrollTo(0, currentScroll - 100);
          }
        }, 6);
      });
    },
    selectContent(event) {
      if (this.rechargeAmount == 0) {
        event.target.select();
      }
    },
    applyCouponClick() {
      // console.log(this.apiDataObj.userId)
      if (this.applyCouponImg == 0) {
        this.removeCoupon();
      } else {
        if (this.rechargeAmount == 0) {
          this.showToast = true;
          this.toastMessage = "Please enter amount";
          setTimeout(() => {
            this.showToast = false;
          }, 2000);
        } else {
          window.location.href = process.env.VUE_BASE_URL + "/a/wc";
          //window.location.href = "http://localhost:4000/a/wc";
          sessionStorage.setItem("rechargeAmount", this.rechargeAmount);
          sessionStorage.setItem("userId", this.apiDataObj.userId);
        }
      }
    },
    checkCouponApplied() {
      this.isCouponApplied = true;
      this.couponCode = sessionStorage.getItem("promoStr");
      if (this.couponCode != "") {
        this.setWalletData();
      }
      if (sessionStorage.getItem("showDialog") == "true") {
        this.showDialog = true;
        setTimeout(() => {
          this.showDialog = false;
        }, 15000);
      }
    },
    setWalletData() {
      this.verifyWalletResponse = JSON.parse(
        sessionStorage.getItem("verifyWalletResponse")
      );
      this.applyCouponImg = 0;
      this.couponMsg =
        "Rs " + this.verifyWalletResponse.cashback + "/- cashback applied.";
      this.isGreen = 1;
      this.walletCouponMsg = "Code " + this.couponCode + " Applied";

      this.rechargeAmount = sessionStorage.getItem("rechargeAmount")
        ? sessionStorage.getItem("rechargeAmount")
        : 0;
      if (
        this.verifyWalletResponse.original_offer_min_recharge_amount != null
      ) {
        if (
          this.rechargeAmount <
          this.verifyWalletResponse.original_offer_min_recharge_amount
        ) {
          var inputElement = document.getElementById("txn_amt");
          inputElement.value =
            this.verifyWalletResponse.original_offer_min_recharge_amount;
          this.rechargeAmount =
            this.verifyWalletResponse.original_offer_min_recharge_amount;
          sessionStorage.setItem("rechargeAmount", this.rechargeAmount);
          // console.log(inputElement.value)
        }
      } else {
        let txnAmountInput = document.getElementById("txn_amt");
        txnAmountInput.value = Number(this.rechargeAmount);
      }
      // console.log(this.verifyWalletResponse)
    },
    checkCorrectCouponApplied() {
      // priya
      if (
        document.getElementById("txn_amt").value <
        this.verifyWalletResponse.original_offer_min_recharge_amount
      ) {
        this.showCouponAlert();
      } else {
        this.promoCodeId = this.verifyWalletResponse.promo_code_id;
        this.promoCodeStr = this.verifyWalletResponse.promo_code_str;
        this.cashback = this.verifyWalletResponse.cashback;
        this.generateChecksum();
      }
    },
    showCouponAlert() {
      this.showCouponAlertBox = true;
      this.alertHeading = this.couponCode + " Coupon";
      this.alertMessage =
        "You have applied " +
        this.couponCode +
        " Coupon. Please enter Recharge Amount more than Rs " +
        this.verifyWalletResponse.original_offer_min_recharge_amount +
        "/-";
    },
    handleRetry(event) {
      this.showCouponAlertBox = false;
      event.preventDefault();
      this.$refs.amountInput.focus();
    },
    handleIgnoreCoupon(event) {
      this.walletCouponMsg = "Avail Offers / Coupons";
      this.removeCoupon();
      this.generateChecksum();
      event.preventDefault();
    },
    removeCoupon() {
      this.showCouponAlertBox = false;
      this.isCouponApplied = false;
      this.applyCouponImg = 1;
      this.couponMsg = "";
      this.isGreen = 0;
      this.walletCouponMsg = "Avail Offers / Coupons";
      this.promoCodeId = "0";
      this.promoCodeStr = "";
      this.cashback = "0";
      sessionStorage.removeItem("verifyWalletResponse");
      sessionStorage.removeItem("rechargeAmount");
      sessionStorage.removeItem("showDialog");
      sessionStorage.removeItem("promoStr");
      this.showToast = true;
      this.toastMessage = "Coupon is removed";
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },
  },
};
</script>
  <style>
.loading-icon:before {
  content: "Wait...";
}
.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3cb6c3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
/*.navbar,.copyright,.footer {display: none;}*/
.quickPaymentButton {
  background-color: #7cc3cc;
  color: white;
  border: none;
  border-radius: 5% 5% 5% 5%;
  width: 100px;
  height: 2.5rem;
  margin-bottom: 10px;
}
.button3 {
  background-color: #3cb6c3;
  padding: 3% 20% 3% 20%;
  margin-bottom: 40%;
  color: white;
  border: none;
  border-radius: 5% 5% 5% 5%;
}
.button5 {
  background-color: #3cb6c3;
  padding: 5px 20px 5px 20px;
  margin-bottom: 40%;
  color: white;
  border: none;
  border-radius: 5% 5% 5% 5%;
}
.amount_text {
  background-color: transparent;
  border: 0px solid #6c757d69;
  border-bottom-width: 1px;
  width: 100px;
  text-align: center;
  font-weight: 700;
}
.pending_wallet {
  font-size: 35px;
  margin-top: 20px;
}
body,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6,
b,
input,
button,
select,
optgroup,
textarea,
article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
a {
  font-family: Calibari !important;
}
input[type="radio"] {
  transform: scale(1.5);
}
.paymentType label {
  padding-left: 5px;
  width: 75%;
}
.paymentType img {
  width: 45px !important;
  height: 45px !important;
}
input[type="radio"]:checked {
  background-color: teal;
  background: teal;
  border-color: teal;
}

/* priya (coupon) */
.con {
  /* display: flex;
      align-items: center;
      justify-content: center; */
  /* height: 70vh; */
  font-size: 20px;
}
.wallet_coupon_block {
  display: flex;
  flex-direction: column;
  border: 2px solid #3cb6c3;
  border-radius: 10px;
  padding: 8px;
  margin-top: 20px;
  /* border-radius: 290486px; */
}
.wallet_coupon_rl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 20px;
  margin-bottom: 10px;
  /* border: 1px solid gray; */
}
.wallet_coupon_et {
  margin-right: 50px;
  font-size: 15px;
}
.apply_block {
  display: flex;
  align-items: center;
  justify-content: center;
}
.apply_block p {
  margin-bottom: 0;
  margin-left: 10px;
}
.wallet_coupon_heading {
  text-align: left;
  font-weight: bold;
}
.coupon_img:hover {
  cursor: pointer;
}
.wallet_coupon_rl img {
  width: 30px;
  height: auto;
}
.dialogBox {
  position: fixed;
  top: 20%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex;
}
.dialogBox svg {
  width: 100vw !important;
}
.dialogContent {
  background-color: white;
  width: 350px;
  height: 300px;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 100px;
}
.dialogContent p {
  text-align: center;
}

.closeIcon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.circle {
  width: 200px;
  height: 200px;
  background-color: rgb(144, 144, 255);
  border-radius: 50%;
  position: relative;
  overflow: hidden;
}
.circle p {
  text-align: center;
}
.gift {
  width: 120px;
  height: 120px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  animation: popUp 2s ease-in-out infinite;
}
.piece {
  width: 20px;
  height: 20px;
  /* background-color: red; */
  position: absolute;
  opacity: 0;
  animation: scatter 2s ease-in-out infinite;
}
@keyframes popUp {
  0% {
    bottom: -100px;
  }
  50% {
    bottom: 40px;
  }
  100% {
    bottom: -30px;
  }
}

/* Animation for the pieces */
@keyframes scatter {
  0% {
    opacity: 0;
    transform: translateY(0) rotate(0);
  }
  100% {
    opacity: 1;
    transform: translateY(-200px) rotate(720deg);
  }
}
.checkAmtBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  /* align-items: center; */
  align-items: flex-end;
}
.alert-box {
  width: 300px;
  padding: 20px;
  /* height: 220px; */
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 300px;
}
.alert-box h4 {
  margin-top: 0;
  margin-bottom: 10px;
  letter-spacing: 0px !important;
  font-size: 16px;
}
.alert-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.alert-box p {
  text-align: center !important;
  font-size: 14px;
}

.alert-btn button {
  background-color: #3cb6c3;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5% 5% 5% 5%;
  margin: 0px 10px;
}
.toast {
  position: fixed;
  bottom: 60%;
  left: 50%;
  transform: translateX(-50%);
  /* left: '50%'; */
  /* top: 200px; */
  padding: 8px 15px;
  border-radius: 5px;
  color: white;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.726);
  font-size: 14px;
}
.wallet_coupon_msg {
  /* margin-left: 0 !important; */
  font-size: 12px;
  font-weight: bold;
  text-align: left;
}
/* .alert-btn button:hover {
      background-color: #0056b3;s
    } */
@media screen and (max-width: 385px) {
  .dialogBox svg {
    width: 100% !important;
  }
  .paymentType label {
    width: 70% !important;
  }
  .dialogContent p {
    font-size: 15px;
  }
  .dialogContent {
    width: 200px;
    height: 250px;
  }
  .circle {
    width: 150px;
    height: 150px;
  }
  .gift {
    width: 80px;
    height: 80px;
  }
  .closeIcon img {
    height: 35px;
  }
  .apply_block p {
    text-align: left;
  }
}
@media screen and (max-width: 345px) {
  .paymentType label {
    width: 65% !important;
  }
}
@media screen and (max-width: 420px) {
  .wallet_coupon_et {
    margin-right: 5px;
  }
  .apply_block p {
    margin-left: 5px;
  }
  .wallet_coupon_rl {
    margin: 2px 0px;
  }

  .paymentType label {
    width: 70%;
  }
  .dialogContent p {
    font-size: 15px;
  }
  .dialogContent {
    width: 200px;
    height: 250px;
  }
  .circle {
    width: 150px;
    height: 150px;
  }
  .gift {
    width: 80px;
    height: 80px;
  }
  .closeIcon img {
    height: 30px;
  }
  .alert-btn button {
    padding: 5px 10px;
    font-size: 14px;
  }
}
@media screen and (max-width: 900px) {
  .dialogContent {
    margin-bottom: 350px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/P.vue